import { useEffect, useState } from "react"
import { io, Socket } from "socket.io-client"
import { SERVER_URL } from "../../api/axios"

const useSocket = () => {
  const [socket, setSocket] = useState<Socket<any>>()

  useEffect(() => {
    const s = io(`${SERVER_URL}/api/v1`)
    setSocket(s)
    return () => {
      s.disconnect()
    }
  }, [])

  return socket
}

export default useSocket
